import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { getBlogById } from '../../data/blogData';

const BlogPost = () => {
  const { blogId } = useParams();
  const navigate = useNavigate();
  const post = getBlogById(blogId);
  const [content, setContent] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!post) {
      navigate('/');
      return;
    }

    const loadContent = async () => {
      try {
        const response = await fetch(`/public/content/posts/${post.markdownFile}`);
        if (!response.ok) {
          throw new Error('Failed to load content');
        }
        const text = await response.text();
        setContent(text);
      } catch (err) {
        setError(err.message);
        console.error('Error loading markdown:', err);
      } finally {
      }
    };

    loadContent();
  }, [post, navigate]);


  if (error || !post) {
    return (
      <div className="min-h-screen bg-black text-green-400 font-mono p-8">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="text-green-400 hover:text-green-300">
            ← Back to Home
          </Link>
          <h1 className="text-4xl mt-8">
            {error || 'Post not found'}
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-green-400 font-mono p-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="text-green-400 hover:text-green-300 mb-8 inline-block">
          ← Back to Home
        </Link>
        
        <article className="space-y-6">
          <header className="space-y-4 mb-8">
            {post.category && (
              <span className="px-2 py-1 bg-green-500/20 text-green-500 rounded text-sm">
                {post.category}
              </span>
            )}
            <h1 className="text-4xl font-bold">{post.title}</h1>
            <time className="text-gray-400">{post.date}</time>
          </header>
          
          <div className="prose prose-invert prose-green max-w-none">
            <ReactMarkdown>{content}</ReactMarkdown>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;